import { Fragment, useContext, useState } from "react";
import { Card, Row, Button } from "reactstrap";
import QuetionForm from "../Components/QuetionForm";
import { useMutation } from "@apollo/client";
import { UPDATE_BAROMETER } from "../../../../queries";
import { AnswerContext } from "./AnswerContext";
import { useOrgPk } from "../../../../Layout/AppMain/LoginStatusContext";

const Quetionnair = () => {
  const [done, setDone] = useState(false);
  const [updateBaro, { data }] = useMutation(UPDATE_BAROMETER);
  const {
    answer,
    currentQuetionCategory,
    nextQuetion,
    lastPage,
    previousQuetion,
  } = useContext(AnswerContext);
  const orgPk = useOrgPk();

  const update = async () => {
    try {
      const id = Number(orgPk);
      await updateBaro({
        variables: { orgId: id, answer: answer },
      });
      await setDone(!done);
    } catch (err) {
      alert("タイムアウト");
      window.location.href = "/";
    }
  };

  const move = () => {
    window.location.href = "/#/dashboards/analytics?doneDiagnose";
  };

  const childComponent = done ? (
    <Card className="mb-2 org_contentarea financialcomparison">
      <div>
        <Fragment>
          <div className="form-wizard-content">
            <div className="no-results">
              <div className="sa-icon sa-success animate">
                <span className="sa-line sa-tip animateSuccessTip" />
                <span className="sa-line sa-long animateSuccessLong" />
                <div className="sa-placeholder" />
                <div className="sa-fix" />
              </div>
              <div className="results-subtitle mt-4"></div>
              <div className="results-title">診断終了!</div>
              <div className="mt-3 mb-3" />
              <div className="text-center">
                <Button
                  color="success"
                  size="lg"
                  className="btn-shadow btn-wide"
                  onClick={(e) => {
                    move();
                  }}
                >
                  診断結果を見る
                </Button>
              </div>
            </div>
          </div>
        </Fragment>
      </div>
    </Card>
  ) : (
    <Card className="mb-2 org_contentarea financialcomparison">
      <QuetionForm page_num={currentQuetionCategory} />
      <Row className="ema__flex_quetion">
        {lastPage ? (
          <>
            <Button
              onClick={() => previousQuetion()}
              className="ema__btn__main__lg"
            >
              前へ
            </Button>
            <Button onClick={() => update()} className="ema__btn__main__lg">
              回答を送信する
            </Button>
          </>
        ) : (
          <>
            {currentQuetionCategory === 0 ? (
              <Button disabled className="ema__btn__main__lg">
                前へ
              </Button>
            ) : (
              <Button
                onClick={() => previousQuetion()}
                className="ema__btn__main__lg"
              >
                前へ
              </Button>
            )}
            <Button
              onClick={() => nextQuetion()}
              className="ema__btn__main__lg"
            >
              次へ
            </Button>
          </>
        )}
      </Row>
    </Card>
  );
  return <Fragment>{childComponent}</Fragment>;
};

export default Quetionnair;
